import { render, staticRenderFns } from "./ModalBuscarItens.vue?vue&type=template&id=6e37772f&"
import script from "./ModalBuscarItens.vue?vue&type=script&lang=js&"
export * from "./ModalBuscarItens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports